<app-stages [stages]='stages' currentStage='Lokalizacja'></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete='off' novalidate [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    @if (application()?.service?.url === '/zgoda-przebudowa-remont-obiektow-budowlanych') {
      <div class="row">
        <div class="col-12">
          <app-alert [closable]="false">
            Aby wyświetlić dodatkowe dane o sieciach uzbrojenia, można włączyć podkład WMS w drzewku warstw:
            <strong>Warstwy WMS → Publiczna → Krajowa Integracja Uzbrojenia Terenu (GESUT)</strong>
          </app-alert>
        </div>
      </div>
    }
    <app-exposed-map-control #mapControl [control]="form.geometry">
    </app-exposed-map-control>
    <app-road-controls-set [expMapDict]="mapControl.dictEvent()" [form]="form"></app-road-controls-set>
    @if (form.roadCategory; as roadCategory) {
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadCategory" as controlName'>
            <label [for]='controlName'>
              Kategoria drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Gminna'>Gminna</option>
              <option value='Powiatowa'>Powiatowa</option>
            </select>
            <app-validation-errors [control]='roadCategory'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.showDateControls) {
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"endDate" as controlName'>
            <label [for]='controlName'>
              Data do *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.length && form.width && form.area) {
      <fieldset>
        <legend>
          Powierzchnia urządzenia obcego/obiektu budowlanego
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"length" as controlName'>
              <label [for]='controlName'>
                Długość (m)
              </label>
              <input
                (change)='form.calcArea()'
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu szerokość'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"width" as controlName'>
              <label [for]='controlName'>
                Szerokość (m)
              </label>
              <input
                (change)='form.calcArea()'
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu długość'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"area" as controlName'>
              <label [for]='controlName'>
                Powierzchnia (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Powierzchnia'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
    <div class="row">
      @if (form.taskName) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"taskName" as controlName'>
            <label [for]='controlName'>
              Zjazd dotyczy *
            </label>
            <select
              (change)="form.taskNameChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.taskNameList; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.description) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"description" as controlName'>
            <label [for]='controlName'>
              Opis *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu czego dotyczy zjazd'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (!!form.locationDecisions) {
      <fieldset>
        <legend>
          Decyzje lokalizacyjne
        </legend>
        <app-location-decisions-crud formControlName="locationDecisions"></app-location-decisions-crud>
      </fieldset>
    }
    <fieldset>
      <legend>
        {{ application() | fieldsetParcelsLabel }}
      </legend>
      <app-parcels-crud [expMapDict]="mapControl.dictEvent()" tag="parcels"
                        formControlName="parcels"></app-parcels-crud>
    </fieldset>
    @if (form.surfaceType) {
      <div class="row">
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"surfaceType" as controlName'>
            <label [for]='controlName'>
              Rodzaj nawierzchni zjazdu *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nawierzchni zjazdu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.opinionOnTheMatterDesc) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"opinionOnTheMatterDesc" as controlName'>
            <label [for]='controlName'>
              Wskazanie sposobu zmiany zagospodarowania terenu przyległego do pasa drogowego (wskazanie rodzaju
              inwestycji) *
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu wskazanie sposobu zmiany zagospodarowania terenu'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.objectNameOrDevice) {
      <div class="row">
        <div class='col-12'>
          <div class='form-group' *ngIf='"objectNameOrDevice" as controlName'>
            <label [for]='controlName'>
              Nazwa obiektu/urządzenia *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę obiektu/urządzenia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.objectNameOrAdvertisementDesc) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"objectNameOrAdvertisementDesc" as controlName'>
            <label [for]='controlName'>
              {{ application() | objectNameOrAdvertisementDescLabel }} *
            </label>
            <textarea
              rows="2"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu opis'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.distance) {
      <div class="row">
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"distance" as controlName'>
            <label [for]='controlName'>
              {{ application() | distanceLabel }} (m) *
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu odległość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.constructionTechnologyDescription) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"constructionTechnologyDescription" as controlName'>
            <label [for]='controlName'>
              Opis dotyczący określenia technologii prowadzenia robót budowlanych związanych z lokalizacją w pasie
              drogowym liniowych urządzeń obcych *
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu opis'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.leasePurpose) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"leasePurpose" as controlName'>
            <label [for]='controlName'>
              Cel udostępnienia pasa drogowego (wraz z przytoczeniem podstawy prawnej) *
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu cel udostępnienia pasa drogowego'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
  </form>
  <div class='application-actions'>
    <button
      [disabled]='pending()'
      (click)='onCancel()'
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)='submitAndGoNext()'
      [disabled]='pending()'
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
